// ============================================================================
// Ask Sophie token-by-token streaming — flag, endpoint and UI copy.
// ----------------------------------------------------------------------------
// Rollback is flipping REACT_APP_RAG_STREAM_ENABLED off: with the flag off the
// sidebar takes the untouched axios /askanything path and a doctor sees exactly
// today's behaviour. No backend deploy is involved either way.
//
// The stream has its own base URL because it could not live on App Engine: App
// Engine Standard buffers the whole response (measured, not assumed — see
// tikcare_rag docs/STREAMING-DESIGN.md §1), so /askanything_stream ships on
// Cloud Run. Since dev/uat moved every rag route onto that Cloud Run service
// the two URLs are the same host there; they stay separate settings so prod,
// still on App Engine rag-production, can keep the stream off.
// ============================================================================

export const RAG_STREAM_URL = process.env.REACT_APP_RAG_STREAM_URL || '';

// The flag alone is not enough: /askanything_stream only works on a Cloud Run
// host, so a build with the flag on and the URL unset would POST it to an App
// Engine host, get a 404 on every single question, and show a doctor the generic
// error bubble for 100% of turns. A missing URL is a build-time mistake and must
// degrade to the blocking path, which always works — not to a total outage.
export const RAG_STREAM_ENABLED =
  process.env.REACT_APP_RAG_STREAM_ENABLED === 'true' && RAG_STREAM_URL !== '';

export const ASK_SOPHIE_STREAM_PATH = '/askanything_stream';

// The backend sends a machine stage key; the words live here so copy and
// language can change without a backend deploy. Any stage key we do not know
// leaves the previous label on screen rather than showing a raw key.
// NEVER put a patient name or a document title in these: the sidebar is often
// on a screen someone else can see.
export const STAGE_LABELS = {
  understanding: 'Reading your question',
  reading_report: 'Opening the report',
  // "Client", not "patient": that is the word the Scribe UI uses everywhere else,
  // and these labels sit in a sidebar that is often on a screen someone else can see.
  searching_documents: "Searching the client's documents",
  reading_record: 'Reading the client record',
  rewriting_report: 'Rewriting the report',
  // Two stages, not one, because the wait and the writing are genuinely two
  // things: the model takes several seconds to produce its first token and only
  // a few more to produce the rest. "Writing" across that silence would be a
  // promise the wire is not keeping; `writing` arrives with the first token.
  thinking: 'Sophie is thinking',
  writing: 'Writing the answer',
};

// Shown under a bubble whose stream never delivered its `done` event. The text
// is rendered, never stored: a truncated answer is not written to textmessages
// at all, because that table has no status column and is re-rendered later out
// of context, where a half-finished clinical answer reads as a complete one.
export const TRUNCATION_NOTICE =
  'This answer was cut off and was not saved. Please ask again.';
